import React, { memo, useState, useEffect } from 'react';
import axios from "axios";
import css from "./Top.css";
import { generarRutaPerfilSIC } from "../../stores/actions/rutaPerfil";

const dominio = process.env.REACT_APP_DOMINIO;

function Eventos(props) {

  let [topSymbols, setTopSymbols] = useState([]);
  let [tableHtml, setTableHtml] = useState([]);

  async function generarRutaPerfilSICDeLista(lista) {
    for (let element of lista) {
      element.url = await generarRutaPerfilSIC(element.emisora.split(' ')[0]);
    }
    return lista;
  }

  useEffect(() => {
    let urlTop = `${dominio}/cms/o/statistics/etfs/top`;
    axios.get(urlTop)
      .then(response => {
        return generarRutaPerfilSICDeLista(response.data);
      })
      .then(response => {
        setTopSymbols(response);
      })
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    let tmpTopEtfsHtml = [];
    if(topSymbols && topSymbols instanceof Array) {
      topSymbols.forEach((element, index) => {
        tmpTopEtfsHtml.push(
          <tr onClick={() => window.open(element.url, "_blank")} key={`ETFTop_${element.posicion}`}>
            <td>{element.posicion}</td>
            <td><strong>{element.emisora}</strong></td>
            <td>{element.importe}</td>
            <td><p>{element.participacion}</p></td>
          </tr>
        );
      })
    }
    setTableHtml(tmpTopEtfsHtml);
  }, [topSymbols]);

  return (
    <div className="row col-12 sin_padding">
      <div className={[css.fondo, "col-12 sin_padding"].join(" ")}>
      {
        topSymbols.length > 0 ?
          <table className={css.table}>
            <tbody>
              <tr>
                <td className={css.tableHeader}>&nbsp;</td>
                <td className={css.tableHeader}>Emisora</td>
                <td className={css.tableHeader}>Importe</td>
                <td className={css.tableHeader}>Participación</td>
              </tr>
              {tableHtml}
            </tbody>
          </table>
          : ""
      }
      </div>
    </div>
  );
}

export default memo(Eventos);
